

<modal-popup
  *ngIf="curDoc"
  [flexible]="false"
  [hideHeader]="false"
  [title]="curDoc.docName"
  [isOpen]="true"
  (onClose)="closePdfViewer()"
>
  <div class="pdf-container">
    <pdf-viewer
      #docViewer
      [doc]="curDoc"
      [initialPage]="curPage"
      [displayDrawMode]="false"
      [displayToggleBoundingBoxes]="false"
      [singlePage]="false"
      (onToggleAnnotations)="onToggleAnnotations($event)"
      (onIframeLoaded)="onDocIframeLoaded()"
    ></pdf-viewer>
  </div>
</modal-popup>